import React, { useMemo } from 'react'

import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import Separator from '../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../components/pdf/TableHelpers'
import {
  findReplyByQuestionId,
  getReplyValue,
  toDateFormat,
  filterRepliesByQuestionType,
  toPtNumber,
  findReplyByQuestionName
} from '../_helpers/pdfHelpers'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Image from '../../../../components/pdf/Image'

const cleanText = text => text?.trim()?.replace(/[\t\n\\"]/g, '')

const questionWeights = {
  'A obra possui as documentações inicias (SCPO, CNO e SFOBRAS) ?': 2,
  'A obra possui livro de inspeção do trabalho devidamente preenchido (Kallas)?': 2,
  'A obra possui projeto de instalações elétricas provisórias com diagrama unifilar, laudo de aterramento, ART e está atualizado conforme fase de obra?': 3,
  'A obra possui PGR devidamente assinado e atualizado conforme a fase da obra?': 1,
  'O PCMSO contempla as funções e os exames específicos dos colaboradores (Kallas e empreiteiros) que estão atuando no canteiro? Foi aplicado o F-SEG-27 Check list PCMSO?': 2,
  'A obra possui Inventário de riscos? Foi aplicado o F-SEG-26 Check list Inventário de riscos para (Kallas e empreiteiros)?': 3,
  'Os colaboradores próprios e terceiros estão recebendo integração antes do inicio das atividades e as integrações foram registradas no F-SEG-30 e estão no sistema do GD4?': 3,
  "Os colaboradores Kallas e subcontratados estão recebendo os EPI's conforme os riscos e está sendo registrado na ficha de EPI?": 1,
  'Desigando de CIPA (carta de nomeação e Certificado): Existe 01(um) do grupo kallas e um de cada empreiteiro com efetivo a partir de 05(cinco) colaboradores?': 3,
  'Foi implantado o comitê de segurança, juntamente com os designados da CIPA, realizando reuniões mensais utilizando F-ADM-01 Ata de reunião?': 1,
  'Os atestados de saúde ocupacional (ASO) da equipe de obra são controlados e estão válidos?': 3,
  'Os documentos mensais estão sendo enviados? (DSS, controle de emissões de fumaça preta, comprovante de entrega de EPI, NR18- periódico, documentos de instalações elétricas provisórias, inventário de máquinas e equipamentos).': 1,
  'Os documentos quinzenais estão sendo enviados (Relatório fotográfico e relatório de Covid) ?': 1,
  'Está sendo realizado uploud dos documentos no TRC do Grupo Kallas e empreiteiras?': 1,
  'Os funcionários estão sendo cadastrados no TRC e os crachás são emitidos e entregues ao colaborador?': 1,
  'Os arquivos na rede estão sendo organizados e arquivados digitalmente conforme a instrução I-SEG-10 (Arquivo digital de segurança e medicina do trabalho) ?': 1,
  'Está sendo analisado as documentações (funcionários e fornecedores) via sistema GD4?': 3,
  'O empreiteiro entregou todas as documentações legais, conforme I-SEG-09 para o inicio das atividades ?': 3,
  'Os treinamentos  de Segurança do trabalho estão sendo  realizados de acordo com o I-SEG-02 Treinamentos - SST , utilizando F-SEG-37 lista de presença de treinamento e/ ou certificados ?': 1,
  'Os equipamentos (Mini grua - *Grua / Cremalheira) possuem todas as documentações inerentes ao equipamento, tais como ART contendo:   montagem , desmontagem, ascenção,  manutenção , manual e entrega técnica.    *Em caso de Grua deve constar operação na ART.': 1,
  'Está sendo preenchido o Plano de carga (F-SEG-38), Programa de manutenção preventiva: Elevador cremalheira (F-SEG-44) e grua /grua de pequeno porte (F-SEG-45)?': 3,
  'A instalação dos equipamentos foram acompanhados conforme check list de liberação? (F-SEG-07 - Check list Liberação - Betoneira,F-SEG-08 - Check list Liberação - Compressor estacionário,F-SEG-09 - Check list Liberação - Serra Mármore Makita, F-SEG-10 - Check List Liberação -Andaime suspenso, F-SEG-11- Check list Liberação- Cadeira suspensa, F-SEG-12 - Check list liberação - Misturador de argamassa)': 1,
  "Os check list's de máquinas e equipamentos estão sendo realizados adequadamente, conforme os formulários no Autodoc e/ou fornecedores?": 1,
  'Os operadores dos equipamentos foram treinados? (certificado e/ou lista de presença de treinamento).': 1,
  'As mudanças estão sendo planejadas e registradas, conforme F-GQP-02  Planejamento de Mudanças?': 2,
  'Os funcionários foram devidamente treinados para atuação como brigadistas e estão contemplados no organograma de brigada de incêndio conforme o formulário (M-SEG-07)?': 2,
  'Em caso de autuação ou notificação referente a fiscalização de órgãos legais, as causas foram identificadas e os planos de ações definidos?': 3,
  'Foi realizado as tratativas após a auditoria da assessoria de segurança e foi enviado o contra relatório dentro no prazo de 10 dias corridos com todos os envolvidos?': 1,
  'São realizados treinamento e/ou DS a fim de conscientizar os colaboradores, sobre acidentes de trabalho, doenças ocupacionais e mudança de fase de obra utilizando o F-SEG-05 Relatório de diálogo semanal e/ou F-SEG-37 lista de presença de treinamento?': 1,
  'Após a ocorrência de acidente: Kallas: Foi solicitado a CAT ao RH e o F-SEG-06 Relatório interno de investigação de acidente foi emitido? Terceiros: Os documentos solicitados foram enviados para o SST? (F-SEG-06 Relatório interno de investigação de acidente, atestado medico, CAT, inventário de riscos, PCMSO e documentos do colaborador)': 1,
  'O formulario M-SEG-08 (Fluxograma de atendimento a emergência) está distribuido no canteiro e as suas diretrizes informadas aos colaboradores?': 1,
  'Está sendo realizado o plano de emergência conforme o (F-SEG-28) e está atualizado?': 1,
  'Está sendo distribuído no canteiro a sinalização do local de atendimento médico (Localizado no plano de emergência F-SEG-28 )mais próximo do endereço da obra ?': 1,
  'Houve advertência de colaborador? Foi evidenciado através do F-SEG-25- Advertências?': 2,
  'A obra realizou reunião com responsáveis das empresas contratadas a fim de informar as obrigatoriedades na execução das atividades da obra utilizando F-ADM-01 Ata de reunião e o I-SEG-09 Regras e condutas?': 2,
  'A entrada de visitantes na obra está sendo controlada através do F-SEG-02 Controle Manual de Portaria e o está sendo arquivado?': 2,
  'Os cadastros faciais dos colaboradores estão sendo realizados e eles acessam via catraca?': 1,
  'O acesso de pessoas nas áreas de circulação interna está limpo e desimpedido?': 2,
  'A Obra possui  sinalização através de placas  e cartazes distribuídos de acordo com os riscos existentes, áreas de vivência, Ações mensais, identificação dos Pavimentos, politica de qualidade e acesso á administração da obra? Conforme o (M-SEG-01) e (M-SEG-02).': 1,
  'Os extintores estão em sendo intercalados conforme P-OBR-01? Estão em bom estado e com o checklist em dia?': 2,
  'A obra possui TV de no mínimo 32 polegadas, caixa de som, microfone , Plastificadora, camera, headset e computador conforme P-OBR-01 ?': 1,
  'As proteções pré e pós concretagem estão sendo executadas conforme (P-OBR-01) contendo projeto elaborado por profissional legalmente habilitado?': 3,
  'A obra possui plataforma de proteção principal, instalada conforme projeto elaborado por profissional legalmente habilitado?': 3,
  'Os poços estão sendo fechados conforme o PGR ? (Malha, assoalho e proteção rigída)': 2,
  'As redes piso a piso estão em boas condições contendo a sinalização com tela tapume e sendo preenchido o checklist?': 3,
  'O sistema SLQA está instalado conforme consta no projeto?  As proteções metálicas estão sendo instaladas no pavimento de amarração do sistema SLQA?': 3,
  'A tela de fachada está em boa condição de uso, abrangendo todo perimetro da edificação?': 3,
  'O isolamento das áreas de trabalho após a remoção da plataforma está sendo executado conforme o I-SEG-05?': 3,
  'Estão sendo instalados os sanitários nos pavimentos conforme a I-SEG-22?': 2,
  'Estão sendo instalados os bebedouros nos pavimentos conforme a I-SEG-22?': 2,
  'A instalação sanitária está dimensionada na proporção que atenda o efetivo da obra, de acordo com a NR18, NR24 e cartilha pré-obra (M-SEG-6)?': 3,
  'O vestiário está dimensionado na proporção que atenda o efetivo da obra, de acordo com a NR18, NR24 e cartilha pré-obra (M-SEG-6)?': 3,
  'O refeitório está dimensionado na proporção que atenda o efetivo da obra, de acordo com a NR18, NR24 e cartilha pré-obra (M-SEG-6)?': 3
}

const replyIdsByCategory = {
  'Segurança do trabalho - Documentação': [
    42, 43, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107,
    108, 109, 110, 111, 112, 113, 114, 115
  ],
  'Segurança do trabalho - Canteiro de obras': [
    45, 46, 47, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130
  ]
}

const RequirementReplies = ({ replyIds, totalPesos }) => {
  const { replies } = useServiceOrder()

  const validReplies = replyIds.filter(replyId => {
    const reply = findReplyByQuestionId(replies, replyId)
    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    return replyValue !== 'N/A'
  })

  return (
    <>
      {validReplies.map(replyId => {
        const reply = findReplyByQuestionId(replies, replyId)
        const replyValue = getReplyValue(reply).trim()
        const absoluteValue = Number(replyValue?.split('=')?.[0])
        let value
        let peso = 0
        let questionName = cleanText(reply?.question?.name)
        if (typeof absoluteValue === 'number') {
          peso = questionWeights[questionName]
          value = absoluteValue
        } else {
          value = 'ÑAPLICA'
        }
        return (
          <TableRow key={replyId}>
            <TableCol>{reply?.question?.name}</TableCol>
            <TableCol style={{ verticalAlign: 'middle' }} align="center">
              <Text bold align={'center'}>
                {value}
              </Text>
            </TableCol>
          </TableRow>
        )
      })}
    </>
  )
}

const Requirement = ({ categoryName, replyIds, totalPesos, data }) => {
  const { replies } = useServiceOrder()

  const hasValidReplies = replyIds.some(replyId => {
    const reply = findReplyByQuestionId(replies, replyId)
    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    return replyValue !== 'N/A'
  })

  if (!hasValidReplies) {
    return null
  }

  return (
    <>
      <TableRow>
        <TableColText colSpan={2} bold bgColor={'#BFBFBF'} align="center">
          {categoryName}
        </TableColText>
      </TableRow>
      <RequirementReplies replyIds={replyIds} totalPesos={totalPesos} />
    </>
  )
}

const hasValidNotas = replies => {
  return Object.keys(questionWeights).some(question => {
    const reply = replies.find(reply => cleanText(reply?.question?.name) === cleanText(question))

    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    if (replyValue === 'N/A') return false

    return reply?.value?.name?.startsWith('1') || reply?.value?.name?.startsWith('2')
  })
}

const Notas = ({ replies }) => {
  if (!hasValidNotas(replies)) {
    return null
  }

  return (
    <Table width="100%">
      <TableRow>
        <TableHeadText width={'70%'} align="center" bold={false}>
          Apontamentos para notas 1 e 2
        </TableHeadText>
        <TableHeadText align="center" bold={false}>
          Graduação
        </TableHeadText>
        <TableHeadText align="center" bold={false}>
          Causas (aplicável apenas para não conformidades)
        </TableHeadText>
      </TableRow>
      {Object.keys(questionWeights).map((question, index) => {
        const reply = replies.find(reply => cleanText(reply?.question?.name) === cleanText(question))

        if (!reply || !reply.value) {
          return null
        }

        const replyValue = getReplyValue(reply).trim()
        if (replyValue === 'N/A') {
          return null
        }

        if (reply?.value?.name?.startsWith('1') || reply?.value?.name?.startsWith('2')) {
          const childrenReplies = replies.filter(r => r?.question?.parentReference === reply?.question?.reference)
          const requisito = findReplyByQuestionName(childrenReplies, 'Requisito')
          const fato = findReplyByQuestionName(childrenReplies, 'Fato')
          const evidencia = findReplyByQuestionName(childrenReplies, 'Evidência')

          return (
            <TableRow key={index}>
              <TableColText width={'70%'}>
                <b>Requisito: </b>
                {requisito?.value}
                <br />
                <b>Fato: </b>
                {fato?.value}
                <br />
                <b>Evidência: </b>
                {evidencia?.value}
              </TableColText>
            </TableRow>
          )
        } else {
          return null
        }
      })}
    </Table>
  )
}

const Fotos = ({ replies }) => {
  const images412 = findReplyByQuestionId(replies, 131)
  const otherImages = filterRepliesByQuestionType(replies, 'gallery')
    .map(reply => reply.value)
    .flat()

  const allImages = [].concat(images412?.value?.length ? images412?.value : []).concat(otherImages)

  if (!allImages?.length) return <></>
  return (
    <>
      <Separator weight={4} />
      <Table width="100%" style={{ pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
        <TableRow>
          <TableColText bold align="center">
            {'Fotos'}
          </TableColText>
        </TableRow>
        {allImages.map(image => {
          return (
            <TableRow key={image?.id} style={{ paddingTop: '10px', pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
              <TableCol style={{ padding: '5px' }}>
                <Image src={image?.src} maxWidth={280} ignoreFixedSize />
              </TableCol>
            </TableRow>
          )
        })}
      </Table>
    </>
  )
}

const Content = () => {
  const { replies, place, endDate, user } = useServiceOrder()
  const date = toDateFormat(endDate, 'DD/MM/YYYY')

  const auditedTeam = getReplyValue(findReplyByQuestionId(replies, 7109))

  const totalPesos = useMemo(() => {
    let total = 0
    Object.keys(questionWeights).forEach(question => {
      const reply = replies.find(reply => reply?.question?.name?.trim() === question?.trim())

      if (!reply || !reply.value) {
        return
      }

      const replyValue = getReplyValue(reply)?.trim()

      if (replyValue === 'N/A') {
        return
      }

      const absoluteValue = Number(replyValue?.split('=')?.[0])
      let peso = 0
      if (typeof absoluteValue === 'number') {
        peso = questionWeights[question]
      }
      total = total + peso
    })
    return total
  }, [replies])

  const data = useMemo(() => {
    let dados = {}
    Object.keys(questionWeights).forEach(question => {
      const reply = replies.find(reply => cleanText(reply?.question?.name) === cleanText(question))

      if (!reply || !reply.value) {
        return
      }

      const replyValue = getReplyValue(reply)?.trim()

      if (replyValue === 'N/A') {
        return
      }

      const replyNumber = Number(replyValue?.split('=')?.[0])
      let value
      let peso = 0
      let finalPercent = 0
      let finalWeight = 0
      if (typeof replyNumber === 'number') {
        let questionName = cleanText(reply?.question?.name)
        peso = questionWeights[questionName]
        value = replyNumber
        finalWeight = (peso * (peso / totalPesos) * 100) / 100

        if (replyNumber > 2) {
          finalPercent = 100
        }
      } else {
        value = 'ÑAPLICA'
      }

      dados[question] = {
        reply: value,
        weight: finalWeight,
        percent: finalWeight * finalPercent
      }
    })
    return dados
  }, [replies, totalPesos])

  const resumo = useMemo(() => {
    let totalPeso = 0
    let percentFinal = 0

    Object.keys(data).forEach(question => {
      let { weight, percent } = data[question]
      weight = weight ? Number(weight) : 0
      percent = percent ? Math.round(Number(percent) * 100) / 100 : 0
      totalPeso += weight
      percentFinal += percent
    })

    return { totalPeso, percentFinal }
  }, [data])

  return (
    <>
      <View pageBreakAfter>
        <Text size={'small'}>
          <Table width="100%">
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Objetivo e escopo:
                </Text>
              </td>
              <td>
                <Text>
                  Objetivo e escopo: Avaliar a aderência aos procedimentos aplicáveis à área e ao processo com base no
                  P-OBR-01, P-SEG-01 e os procedimentos disponiveis na plataforma autodoc qualidade (aba setorial:
                  Segurança do trabalho).
                </Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Obra:
                </Text>
              </td>
              <td>
                <Text>{place.name}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Data:
                </Text>
              </td>
              <td>
                <Text>{date}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Auditor(es):
                </Text>
              </td>
              <td>
                <Text>{user.name}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Equipe auditada:
                </Text>
              </td>
              <td>
                <Text>{auditedTeam}</Text>
              </td>
            </tr>
          </Table>
          <Separator weight={4} />
          <Table width="30%">
            <TableRow>
              <TableColText bold align="center">
                {'ADERÊNCIA'}
              </TableColText>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'1 = Não cumpre o requisito'}</TableCol>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'2 = Cumpre parcialmente o requisito'}</TableCol>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'3 = Cumpre o requisito'}</TableCol>
            </TableRow>
          </Table>
          <Separator weight={4} />
          <Table width="100%" style={{ pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
            <TableRow>
              <TableHeadText width={'85%'} bgColor={'#558ed5'} align="center" color={'white'} bold={false}>
                PROCEDIMENTO DE OBRAS - P-OBR-01
              </TableHeadText>
              <TableHeadText bgColor={'#558ed5'} align="center" color={'white'} bold={false}>
                %Final
              </TableHeadText>
            </TableRow>
            <TableRow>
              <TableColText bold align="left">
                {'OBRAS'}
              </TableColText>
              <TableColText bold align="center">
                {toPtNumber(parseFloat((resumo.percentFinal / resumo.totalPeso).toFixed(2)))}%
              </TableColText>
            </TableRow>

            <Requirement
              data={data}
              categoryName={'Segurança do trabalho - Documentação'}
              replyIds={replyIdsByCategory['Segurança do trabalho - Documentação']}
              totalPesos={totalPesos}
            />

            <Requirement
              data={data}
              categoryName={'Segurança do trabalho - Canteiro de obras'}
              replyIds={replyIdsByCategory['Segurança do trabalho - Canteiro de obras']}
              totalPesos={totalPesos}
            />
          </Table>
          <Separator weight={4} />
          <Notas replies={replies} />
        </Text>
      </View>
      <Separator weight={4} />
      <View pageBreakAfter>
        <Fotos replies={replies} />
      </View>
    </>
  )
}

export default Content
